module.exports = __webpack_public_path__ + "img/syndesia-logo-white.501b5659.svg";